import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { GetAllTimeStorageUsageRequest } from "../proto/api_pb";
import { RpcError } from "grpc-web";
import * as Sentry from "@sentry/react";

export const getStorageUsage = async (
  userId: string,
  accessToken: string,
  enterpriseId: string | undefined
): Promise<number | RpcError | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetAllTimeStorageUsageRequest();
    request.setUserId(userId);
    if (enterpriseId) request.setEnterpriseId(enterpriseId)
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<number | RpcError>((resolve, reject) => {
          ommuseClient.getAllTimeStorageUsage(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response.getStorageUsage());
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
        Sentry.captureException(e);
return undefined;
  }
};
